import ToolBase from '../basic';
import DEFINE from '../define';

export default class Free extends ToolBase {

    name = DEFINE.TOOLS.FREE;

    setting = null;
    freeLine = null;
    path = null;
    isDown = null;
    origX = null;
    origY = null;

    lengthLimit = 5;

    constructor(parent) {
        super(parent);
    }

    recover(object) {
        object.set({
            lockMovementX: true,
            lockMovementY: true,
            hasControls: false,
            hasBorders: false
        })
    }

    create() {
        this.setting = this.parent.getDrawSetting(DEFINE.DRAW_TYPE.LINE_SEGMENT);

        this.canvas.isDrawingMode = true;
        this.canvas.freeDrawingBrush.limitedToCanvasSize = true;
        this.canvas.freeDrawingBrush.color = `${this.setting.fill.slice(0, this.setting.fill.length - 1)},${this.setting.opacity} )`;
        this.canvas.freeDrawingBrush.width = this.setting.strokeWidth;
    }

    mouseDownBefore(o) {
        this.setting = this.parent.getDrawSetting(DEFINE.DRAW_TYPE.LINE_SEGMENT);
        this.canvas.freeDrawingBrush.shadow = null;

        this.canvas.freeDrawingBrush.color = `${this.setting.fill.slice(0, this.setting.fill.length - 1)},${this.setting.opacity} )`;
        this.canvas.freeDrawingBrush.width = this.setting.strokeWidth;

    }

    objectAdded(o) {
        let target = o.target;

        if (this.getTotalLength(target.path) < this.lengthLimit / this.parent.viewportTransform.scale) {
            this.canvas.remove(target);
            this.canvas.renderAll();
        } else {
            target.tag = DEFINE.TAG.FREE + new Date().getTime();
            target.toolType = this.name;
            target.transparentCorners = false;
            target.selectable = true;
            target.lockMovementX = true;
            target.lockMovementY = true;
            target.hasControls = false;
            target.hasBorders = false;
            target.perPixelTargetFind = true;

            this.canvas.renderAll();
            this.parent.addHistory();
        }
    }

    getTotalLength(pathData) {
        let totalLength = 0;

        for (var i = 1; i < pathData.length; i++) {
            var x1 = pathData[i - 1][1];
            var y1 = pathData[i - 1][2];
            var x2 = pathData[i][1];
            var y2 = pathData[i][2];

            var segmentLength = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
            totalLength += segmentLength;
        }

        console.log("線條總長度: " + totalLength);
        return totalLength;
    }
}